export const mapViewportIds = ['full', 'block-a', 'block-b', 'block-c'] as const

export type MapViewportId = (typeof mapViewportIds)[number]

export interface MapViewportBounds {
  x: number
  y: number
  width: number
  height: number
}

const blockAViewportBounds = { x: 771, y: 1293, width: 688, height: 783 }
const blockBViewportBounds = { x: 1461, y: 507, width: 784, height: 672.1 }
const blockCViewportBounds = { x: 2322, y: 507, width: 273, height: 675 }

export const focusedMapViewportBounds: Partial<Record<MapViewportId, MapViewportBounds>> = {
  'block-a': blockAViewportBounds,
  'block-b': blockBViewportBounds,
  'block-c': blockCViewportBounds,
}

export const mapSectionLabels = [
  {
    id: 'block-a',
    label: 'A',
    anchor: { x: 980, y: 1304, width: 54, height: 54 },
  },
  {
    id: 'block-b',
    label: 'B',
    anchor: { x: 1828, y: 772, width: 54, height: 54 },
  },
  {
    id: 'block-c',
    label: 'C',
    anchor: { x: 2435, y: 772, width: 54, height: 54 },
  },
] as const
